import { useContext } from 'react';
import Head from 'next/head';
import styled from 'styled-components';
import { Container } from 'react-bootstrap';
import RestaurantContext from '../Context/RestaurantContext';
import isEmpty from 'lodash/isEmpty';

const Wrapper = styled.div`
  h1 {
    font-weight: 700;

    margin-bottom: 30px;
    font-size: 21px;
    letter-spacing: 0.93px;
    @media (min-width: 768px) {
      margin-bottom: 60px;
      font-size: 31px;
      letter-spacing: 1.38px;
    }
  }

  h2 {
    font-weight: 700;
    margin-bottom: 0;

    font-size: 16px;
    letter-spacing: 0.71px;
    @media (min-width: 768px) {
      font-size: 17px;
      letter-spacing: 0.75px;
    }
  }

  p {
    font-weight: 300;

    letter-spacing: 0.71px;
    font-size: 16px;
    @media (min-width: 768px) {
      letter-spacing: 0.75px;
      font-size: 17px;
    }
  }
`;

function Impress(props) {
  const { restaurantProps: storeProps } = useContext(RestaurantContext);

  const getVatOrTaxNumber = () => {
    if (storeProps.vatId && storeProps.vatId !== '') {
      return `USt-Id: ${storeProps.vatId}`;
    } else if (
      storeProps.taxNumber &&
      storeProps.taxNumber !== '' &&
      storeProps.taxNumber.toLowerCase() !== 'kommt'
    ) {
      return `Steuernummer: ${storeProps.taxNumber}`;
    }
    return 'Steuernummer: beantragt';
  };

  const title = `${storeProps.restaurantName} - Impressum`;
  return (
    <>
      <Head>
        <title>{title}</title>
      </Head>

      <Container>
        <Wrapper>
          <h1>Impressum</h1>

          <h2>Angaben gemäß §5 TMG:</h2>
          <p>
            {storeProps.companyName || storeProps.restaurantName} <br />
            {storeProps.address.street} {storeProps.address.houseNumber} <br />
            {storeProps.address.zip} {storeProps.address.city}
          </p>

          {!isEmpty(storeProps.hrNumber) && (
            <p>
              Handelsregisternummer: {storeProps.hrNumber}{' '}
              {!isEmpty(storeProps.countyCourt) && <>(Amtsgericht {storeProps.countyCourt})</>}
            </p>
          )}

          <h2>Vertreten durch:</h2>
          <p>{storeProps.ceo}</p>

          <h2>Kontakt:</h2>
          <p>
            Telefon: {storeProps.telephoneNumber} <br />
            E-Mail: {storeProps.emailAddress} <br />
            {getVatOrTaxNumber()}
          </p>

          <h2>EU-Streitschlichtung</h2>
          <p>
            Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{' '}
            <a
              href="https://ec.europa.eu/consumers/odr"
              target="_blank"
              rel="nofollow noopener noreferrer"
            >
              https://ec.europa.eu/consumers/odr
            </a>
            . Unsere E-Mail-Adresse finden Sie oben im Impressum.
          </p>

          <h2>Verbraucher­streit­beilegung / Universal­schlichtungs­stelle</h2>
          <p>
            Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
            Verbraucherschlichtungsstelle teilzunehmen.
          </p>

          <h2>Haftungsausschluss</h2>
          <h2>Haftung für Inhalte</h2>
          <p>
            Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten
            nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als
            Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde
            Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige
            Tätigkeit hinweisen.
          </p>
          <p>
            Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den
            allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch
            erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei
            Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend
            entfernen.
          </p>

          <h2>Haftung für Links</h2>
          <p>
            Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen
            Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr
            übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder
            Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der
            Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum
            Zeitpunkt der Verlinkung nicht erkennbar.
          </p>
          <p>
            Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete
            Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von
            Rechtsverletzungen werden wir derartige Links umgehend entfernen.
          </p>

          <h2>Urheberrecht</h2>
          <p>
            Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen
            dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art
            der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen
            Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind
            nur für den privaten, nicht kommerziellen Gebrauch gestattet.
          </p>
          <p>
            Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die
            Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche
            gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden,
            bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen
            werden wir derartige Inhalte umgehend entfernen.
          </p>
        </Wrapper>
      </Container>
    </>
  );
}

export default Impress;
